document.addEventListener('DOMContentLoaded', () => {
  const getOneTime = () => document.querySelector('[data-stayai-onetime-price]')?.textContent.trim() || '';

  const getSubscription = () =>
    document.querySelector('[data-stayai-subscription-price]')?.lastChild.textContent.trim() || '';

  const updatePrice = () => {
    const selected = document.querySelector('input[name="purchaseType"]:checked')?.value;
    const newPrice = selected === 'purchaseTypeSubscription' ? getSubscription() : getOneTime();

    const target = document.querySelector('.selected-product-price');
    if (target) {
      target.innerHTML = `<span class="price-dot tw-flex tw-w-[2px] tw-h-[2px] tw-bg-white"></span> ${newPrice}`;
    }
  };

  document.querySelectorAll('input[name="purchaseType"]').forEach((r) => r.addEventListener('change', updatePrice));

  document.querySelector('.stayai-subscription-dropdown')?.addEventListener('change', updatePrice);
  updatePrice();
});

document.addEventListener('DOMContentLoaded', () => {
  const getOneTime = () => document.querySelector('[data-stayai-onetime-price]')?.textContent.trim() || '';

  const getSubscription = () =>
    document.querySelector('[data-stayai-subscription-price]')?.lastChild.textContent.trim() || '';
  const getSelectedText = () => {
    const selected = document.querySelector('input[name="purchaseType"]:checked')?.value;
    if (selected === 'purchaseTypeSubscription') {
      const label = document.querySelector('.subscription-label');
      if (label) {
        return (
          label.childNodes[0].textContent.trim() +
          ' ' +
          label.querySelector('.subscription-savings')?.textContent.trim()
        );
      }
      return '';
    } else {
      return document.querySelector('.one-time-purchase-label')?.textContent.trim() || '';
    }
  };
  const updateSubscriptionText = () => {
    const selected = document.querySelector('input[name="purchaseType"]:checked')?.value;
    const newPrice = selected === 'purchaseTypeSubscription' ? getSubscription() : getOneTime();
    const newText = getSelectedText();
    const textTarget = document.querySelector('.custom-subscription-title');
    if (textTarget) {
      textTarget.textContent = newText;
    }
  };
  document.querySelectorAll('input[name="purchaseType"]').forEach((r) => {
    r.addEventListener('change', (event) => {
      const purchaseType = event.target.value.toLowerCase();
      if (purchaseType === 'purchasetypeonetime') {
        const oneTimeRadio = document.querySelector('input[data-purchasetype="one-time purchase"]');
        if (oneTimeRadio) {
          oneTimeRadio.click();
        }
      } else if (purchaseType === 'purchasetypesubscription') {
        const subscriptionRadio = document.querySelector('input[data-purchasetype="subscription"]');
        if (subscriptionRadio) {
          subscriptionRadio.click();
        }
      }
      updateSubscriptionText(event);
      getSelectedValue(event);
    });
  });
  document.querySelector('.stayai-subscription-dropdown')?.addEventListener('change', updateSubscriptionText);
  //document.querySelector(".stayai-subscription-dropdown")?.addEventListener("change", getSelectedValue);
  updateSubscriptionText();

  function getSelectedValue() {
    setTimeout(() => {
      const selectedVariant = document.querySelector('.product-form__input .supply-variant:checked').value;
      if (!selectedVariant) return;

      const subscriptionSelect = document.querySelector('.stayai-subscription-box .stayai-subscription-dropdown');
      if (!subscriptionSelect) return;

      if (selectedVariant === '1 Month Supply') {
        subscriptionSelect.value = subscriptionSelect.options[0]?.value;
      } else if (selectedVariant === '3 Month Supply') {
        subscriptionSelect.value = subscriptionSelect.options[1]?.value;
      }

      subscriptionSelect.dispatchEvent(new Event('change'));
    }, 1500);
  }

  if (document.querySelector('.supply-variant')) {
    getSelectedValue();
    document.addEventListener('change', (event) => {
      if (event.target.classList.contains('supply-variant')) {
        getSelectedValue();
      }
    });
  }

  const intervalId = window.setInterval(function () {
    if (document.querySelectorAll('purchase-options').length > 0) {
      const purchaseType = document.querySelector('input[name="purchaseType"]:checked')?.value.toLowerCase();
      if (purchaseType === 'purchasetypeonetime') {
        const oneTimeRadio = document.querySelector('input[data-purchasetype="one-time purchase"]');
        if (oneTimeRadio) {
          oneTimeRadio.click();
        }
      } else if (purchaseType === 'purchasetypesubscription') {
        const subscriptionRadio = document.querySelector('input[data-purchasetype="subscription"]');
        if (subscriptionRadio) {
          subscriptionRadio.click();
        }
      }
      clearInterval(intervalId);
    }
  }, 1000);

  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
});
